#
msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2025-09-17 01:19+0300\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: en-x-arr\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr ""

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr "{0} o' {1} files hoisted"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr "\"{name}\" will be sunk forever. ⚰️"

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr ""

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr ""

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr "1 Naked brute 💪"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr "1 tide 🌊"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr "1 bell-toll 🛎️"

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr "TrueMoney talkbox: 10 digits, startin’ with 0—don’t get clever, Captain. 📱"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr "3 tides 🌊"

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr "6 bell-tolls 🛎️"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr "7 tides 🌊"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr "A trim o’ tribute be slapped on all hired crew 🤝 under this payin’ purse 💸."

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr "We be spawnin’ a mate’s account with this call-sign, Captain. Use it to board the Phantom contraption 👻. Can contain ASCII letters, digits, underscores (_) and hyphens (-). Must start with a letter or underscore. Maximum length be 25 runes—step outta line and ye walk the plank! ☠️"

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr "A VPC be a private slice o’ rigging 🪢 linkin’ piles o’ yer booty. This fancy rigging costs nary a doubloon. 💸"

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr "Say aye 📜"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr "Say aye to the summons 📜"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr "Said aye ☑️"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr "Say “aye,” an’ Captain’ll sail as “{name},” swingin’ every lever in their stead. 🏴‍☠️"

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr "Boardin’ rights 🗝️"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr "Hatch passes 🚪🎟️"

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr "Helm hand‑off ⛵"

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr "Access crew ☠️"

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr "Access has been shared with Captain 🫡"

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr "Boardin’ summons 📜"

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr "Access invite from {0} be bobbin' in limbo ⏳"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr "Hatch pass ID 🆔"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr "Call-sign 🔖"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr "Boardin’ rights scope 🗺️"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr "Type o’ boardin’ rights 🗝️"

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr "Board a matey 🏴‍☠️"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr "Verifyin’ ye ain’t a ghost ship 👻"

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr "Yer account rites must be proven—verifyin’ ye ain’t a ghost ship 👻"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr "Payin’ purse mark 🏷️"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr "Payin’ purse call‑sign 🔖"

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr "Sail as 🎭"

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr "Sailin' as <0>{0}</0>"

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr ""

#. Disk status
#. Service status
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr "Afloat 🏴‍☠️"

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr "Real coin o' yer cargo hold be tallied each bell-toll by what ye actually stash - no tribute upfront, Captain. Each GB ye start counts as a whole GB, rounded up. 🪙⚓️"

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr "Actual booty depends on Engine room ⚙️ and Cargo hold 📦 usage. Persistent volumes of hibernatin’ clusters still rack up coin. Spyglass yer payin’ purse 💸 current usage for the gritty details."

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr "Throw aboard ➕"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr ""

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr "Add extra barrel o’ bits 🛢️"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr "Add fore-name"

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr "Add parrot code 🦜"

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr "Add aft-name"

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr "Tag a call-sign 🔖"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr "Spawn a fresh coin‑route… 🪙"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr ""

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr "Add new rule 🧾"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr "Add a node ➕"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr "Add node pool ➕"

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr "Add coin-route 🪙"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr "Add a coin-route later, Captain ⏳"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr "Add rule 🏴"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr ""

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr "Add sub-rig 🪢"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr "Summon target server 💀"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr "Add mate 🏴‍☠️"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr "Add mates 🏴‍☠️"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr "Adding the coin-route belly‑flopped, Captain. 💥🪙"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr "Hideout marks 🏝️"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr "Hideout marks, line 2 🏝️"

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr "Admiral view 🧭"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr "All hands ☠️"

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr ""

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr "All TCP"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr "All UDP"

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr "Snag a floaty thing and start bossin’ yer riggin’ 🪢 around."

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr "Claimin’ fresh parrot code 🦜 lets Captain lash it to yer current loot or stash it for later plunder. 💰"

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr "Already on the ship’s manifest, Captain? 📝"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr "Booty sum 💰"

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr "That sum be punier than a deck rat—too low! 🐀"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr "Make the sum sail above zero, ye scallywag! ➕"

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr "Don’t lowball it—can’t be less than the minimum booty refill, Captain! ☠️"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr "A lively payin’ purse be needed to forge loot, Captain. 🔧💰"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr "An active payin’ purse be needed to use this bauble, Captain. ⛓️"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr "A parrot post 📬 with orders be sent to Captain. 🦜"

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr "Well, that went swimmin’ly… not. ⚓️🙄"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr "Any"

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr "API 🧰"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr "Admiral’s Port Interface lore 📚"

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr "Captain’s Seal 🔖"

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr "App trove 💰"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr "Paint the hull 🎨"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr "Apply to pay by ransom note 💸"

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr "Ye sure ye wanna sink the sub-rig with uuid {ifUuid}, Captain? ☠️"

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr ""

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr "Ye sure ye want to abandon ship, Captain? 🏃‍♂️⛴️"

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr "Lash to ⚓️"

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr "Moored ⛵"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr "Lashed to ⚓️"

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr "At least one parrot post 📬 be required, Captain. ☠️"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr "At least one IP be required, Captain. ⚓️"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr "At least one node pool must set the autoscaler minimum to 1 or more, else the fleet be toothless, Captain. 🦷"

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr "Latch a port blockade 🛡️"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr "Lash on loot 🪢"

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr "Lashed on 🪢"

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr "Lashed to 🪢"

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr "Let the winds decide 🌬️"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr "Auto‑update ⚙️"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr "Clockwork tribute 🤖💰"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr "Automated booty refill 🤖💰"

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr "Automatic ship‑level Safety stash 🕰️ be enabled. Use the stash snapshots to resurrect yer Hired crew 🤝. The stash be kept 7 days—aye, ye get the latest 7, no more, no less."

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr "Auto‑updates won’t touch the preview beasts. 🐉"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr "Auto‑refill the booty (min. <0/>)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr "Autoscaler max. 🏴‍☠️"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr "Autoscaler min. ⚓️"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr "Up fer the takin’ 🏴‍☠️"

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr ""

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr "Back to the chart 🗺️"

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr "Back to yer account ⤴️"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr "Safety stash 🕰️"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr "Coffer chronicles 📜💰"

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr "Naked iron 🔩"

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr "Naked brute 💪"

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr "Base coinage ⚖️"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr "Kick off yer payin’ purse 💸 proving, Captain! 🏴‍☠️"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr "Below be an example o’ riggin’ this sub-rig on a Linux ironbeast. Don’t set the sails ablaze. 🔧🔥"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr "Payin’ purse 💸"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr "Payin’ purse 💸"

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr "Payin’ purse be shackled ⛓️"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr "Payin’ purse call-sign 🔖"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Billing account suspended"
msgstr "Payin’ purse be in irons ⛔"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr "Payin’ purses 💸"

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr ""

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr "Boot‑flag 🥾"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr "Hoist from ISO medium ⚙️"

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr ""

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr ""

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr ""

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr "Carryin’ on with the booty refill means Captain swears on the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>. ⚓️✍️"

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr "Cuttin’ the safety net means no more auto stashes from yer phantom contraption. What’s already squirreled away stays put—still usable. Captain can raise backups again whenever the winds demand. 🕸️💾"

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr "Pick “Global” and all the loot under this account be fair game. Easy there, Captain—“Global” bites. ☠️"

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr "By pickin’ “Restricted”, access gets shackled to the loot in the chosen payin’ purse 💸. ⛓️"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr "Captain, by swearin’ in, ye bow to the <0>Terms o’ Service</0> ☠️"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr "Campaign rune 🗺️"

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr "Can board me ⚓️"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr "Belay that! 🖐️"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr "Scuttle the hoist ⛔️"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr ""

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr "Plunder tab digits 🧾"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr "Swap ⚔️"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr "Swap the hush-code 🔐"

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr "Swap yer hush‑code by tappin’ the magic link we just lobbed into yer message barrel, Captain. 🔐"

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr "Swappin' the hush-code belly-flopped ⚓️🙄"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr "Only while the phantom contraption 👻 be sailin’ can ye swap the hush-code, Captain."

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr "Pick a payin’ purse fer yer new loot, Captain, to corral all yer spoils under a tidy coin‑route. 🧭🪙"

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr "Pick the payin’ purse 💸 Captain be sharin’ access to. ⛵"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr "Pick some loot to lash the IP to, or leave it adrift. Captain can always hitch it to a worthy crate later. 🛟"

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr ""

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr "Pick a Secret harbor network 🤫⚓️ fer yer loot from the old stock, or chart a fresh private riggin’. 🪢"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr "Pick payin’ purse 💸"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr "Pick yer poison ☠️"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr ""

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr "Port‑town ⚓️"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr "Swabbin’ the decks 🧽"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr "Swab ’em all clean 🧽"

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr "Swab the uploads 🧹"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr ""

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr "Spawn twin 🧪"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr "Spawn twin o’ this loot 🧪"

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr "Shut the hatch 🔒"

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr ""

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr "Crew name 🏴"

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr "Company RNE code 🏷️"

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr "Full Admiral’s Port Interface lore 📚 with code scraps be here:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr "Engine room ⚙️"

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr "Confirm yer parrot post 📬"

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr "Confirm hush-code ✅"

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr "Prove yer squawk address by clickin’ the magic link we just stuffed in yer message barrel, Captain. 🪣🦜"

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr "Swear it, Captain ☠️"

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr "Latch on ⚓️"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr ""

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr "Lashin’ on… 🪢"

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr "Lashin’ on the coin‑route 🪝"

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr "Hook‑up particulars ⚓️"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr "Contact mate’s call-sign 🔖"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr "Contact mate’s speakin’ trumpet 📣"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr "Signal the support crew 🆘"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr "Onward ⛵"

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr "Aye, copied! ⚓️"

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr "Snatch it 📋"

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr "Snatch the scroll to the plankboard 📋"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr "Snatch the public link 📋"

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr "Stash in the clipboard 🗒️"

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr "Ship’s backbone 🛳️"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr "Flag o’ origin 🏴"

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr ""

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr "CPU ⚙️"

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr "Forge ⚒️"

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr ""

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr "Spawn a payin’ purse first—then ye can start craftin’ loot, Captain. 🛠️💰"

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr "Commission a dedicated Naked brute 💪 and run Captain’s app at ramming speed. 🔥"

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr ""

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr "Spawn new access 🐣 so scallywags or contraptions ⚙️ can meddle with this {siteName} account."

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr "Spawn a fresh Barrel o’ bits 🛢️ an’ start stashin’ yer secrets, Captain. 🗝️"

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr "Spawn new loot and get yer hired crew 🤝 sailin’ in minutes. Chop-chop! ⏱️"

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr "Spawn new loot and start wranglin’ yer rigging. 🪢"

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr "Spawn new loot 🐣 o’ a Hired crew 🤝 and have it sailin’ in mere minutes, Captain! ⏱️⛵"

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr ""

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr "Spawn a fresh Phantom contraption 👻 or nab somethin’ from the App Catalog to get Captain’s services runnin’ in minutes… assuming the wind cooperates. ⏱️💨"

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr "Raise a personal Secret harbor network 🤫⚓️ and start wranglin’ yer riggin’ 🪢."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr "Mint a public parrot code 🦜 for this loot"

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr ""

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr "Carve yer name on the manifest 🪵"

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr "Forge a Captain’s Seal 🔖 to work our API 🧰."

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr "Summon yet another {0} 💀"

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr "Raise a payin’ purse, Captain 💸"

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr "Raise a new one ⛵"

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr "Hatched 🐣"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr "Hatchin' date 🐣"

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr "Hatchin’ date 🐣"

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr ""

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr "Spawnin’ ⚗️"

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr "Forgin’ access by Captain’s Seal 🔖 hands Captain a Hatch pass 🚪🎟️ for our API 🧰."

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr "Booty credit 💰"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr ""

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr ""

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr ""

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr "Current plunderin’ ⚔️"

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr "Currently adrift 🛟"

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr "Custom ⚙️"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr "Custom ISO map 🗺️"

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr ""

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr "CVC 🏴‍☠️"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr "Moonlit mode 🌚"

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr "Helm deck 🧭"

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr "Hideout 🏝️ where the loot be lurkin’."

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr "Hideout 🏝️ where the loot’ll be forged."

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr "Data fell overboard 🌊"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr "Logbook date 📜"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr "Spurned / Put in irons ⛔"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr "Default 📌"

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr "Pass helm to ⛵"

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr "Pass the helm to yer user or payin’ purse 💸 so trusted mates can mind yer loot."

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr "Pass new helm ⛵"

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr "Passin’ the helm to a trusted mate lets ’em sail as Captain and yank every lever for yer user or payin’ purse 💸. 🏴‍☠️"

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr "Sink it 🌊"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr "Sink the floaty thing 🔥"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr "Scuttled ⚰️"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Sinkin’ “{display_name}” sends it to Davy Jones’ locker—gone fer good; no spyglass will find it after, Captain. 💀🌊"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr "Sinkin’ “{name}” will forever strip this crew o’ the right to sail as Captain. 💀"

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr ""

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr "Scuttlin’ a backup banishes it forever. 💣"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr "Scuttlin’ a payin’ purse \"{title}\" be forever. Ye can only sink it if no unpaid loot be lashed to it and no spare doubloons be clinkin’ inside. ☠️💸"

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr "Scuttlin’ a coin‑route \"{0}\" will heave it overboard from the payin’ purse 💸."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr "Sinkin’ a Hired crew 🤝 also sinks yer Safety stash 🕰️; no raisin’ it from Davy Jones after, aye. 💀"

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr "Scuttlin’ a soul-freeze sends it to Davy Jones forever. 💀"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr "Scuttlin' the hatch pass \"{accessKey}\" be forever - it can't board the cargo hold via the Admiral's Port Interface after that. ☠️🧰"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr "Scuttlin’ the plunder tab \"{placeholder}\" will banish it from the payin’ purse 💸 forever."

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr "Sinkin’ this barrel o’ bits banishes it forever—no access after, savvy? 💀"

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr "Sinkin’ the floaty IP “{0}” boots it from Captain’s chest and sets it loose in the public shoals. 💀🌊"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr "Scuttlin’ the invoice coin‑route will banish it from the payin’ purse 💸 forever."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Scuttlin’ the Hired crew 🤝 “{display_name}” be permanent—gone to the depths and unreachable thereafter, Captain. 💀"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr "Sinkin' the loot bucket \"{name}\" be permanent, and any files inside won't be reachable after that. Off to Davy Jones they go! 💀🌊"

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr "Sinkin’ the Captain’s Seal 🔖 “{description}” be forever—no more sneakin’ past the hatch after that. ☠️"

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Sinkin’ the phantom contraption \"{name}\" erases it fer good—no comin’ back, no access. 💀"

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr "Scuttlin’ the phantom contraption also torches yer safety stash an’ snapshots—no resurrection after. Want to keep ’em? Drop anchor instead, Captain. ⚓️"

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr "Scuttlin’ the VPC rigging “{name}” yanks it from Captain’s ledger. ⚓️"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr "Tale o’ the thing 📜"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr "Landfalls 🗺️"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr "Ropes be cut ✂️"

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr "Scuttle it 🪓"

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr "Cut the safety net 🕸️"

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr "Douse the sorcery 🔮"

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr "Nay, it be shackled ⛔"

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr "Cut the ropes ✂️"

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr "Ropes be cut ✂️"

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr "Trimmed tribute 💸"

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr "Barrel o’ bits 🛢️"

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr "Barrel I/O 🛢️↕️"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr "Barrel o’ bits can only get bigger—no backsies. This deed be irreversible. Minimum barrel size:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr "Barrels o’ bits 🛢️"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr "Showin’ coinage 💰"

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr "Proof parchment 📜"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr "Parchment scroll 📜"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr ""

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr "Plunder it ⬇️"

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr "Plunder the config parchment ⬇️"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr "Plunder the PDF 📥"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr "Drop yer files here, Captain ⬇️📦"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr "Pay‑by tide 🗓️🌊"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr "Scrawl it ✍️"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr "Scrawl the maintenance ✍️"

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr ""

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr "Scrawl the node ✍️"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr "Tweak rule ✍️"

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr "Mate’s address 🪶"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr "Arrr, the parrot post proof sank! 💀🦜"

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr "Parrot post proven true ✅🦜"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr "Parrot post where the ransom notes and tallies get squawked, Captain. 📬"

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr ""

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr "Awaken it 🔮"

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr "Awaken the sorcery 🔮"

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr "Let other scallywags or contraptions ⚙️ meddle with the loot lashed to this account. 🏴‍☠️"

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr "Aye, it be on ✅"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr ""

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr ""

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr "Punch in a number ’twixt 1–4094, Captain 🏴‍☠️"

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr ""

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr "Punch in the booty refill sum 💰 in {0} (minimum {minimumAmount}):"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr "Cursed blunder ☠️"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr "Arrr! Bungled addin’ the coin-route—went south faster than a leaky scow. 🌊"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr ""

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr "That went south faster than a leaky ship 🌊"

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr ""

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr "Est. moon-turn toll 💸"

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr "Est. haul 💰"

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr ""

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr ""

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr "Every new deckhand nabs {c_totalReceiverCredit} o’ free booty when signin’ up via the referral link or code and addin’ a verified coin‑route. 🪝"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr "Every fresh swabbie who joins via the bounty‑by‑buddies scheme and tops up at least {c_minimumTopUp} bags a bonus o’ {c_totalReceiverCredit} booty. 🎁"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr "Example 🧭"

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr "Coin‑swap rate 🪙"

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr "No {vatSymbol} ☠️"

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr "Fail‑over nodes ⚓️"

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr ""

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr ""

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr ""

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr "Scroll 📜"

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr "Files 📦"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr "Files be hoisted to"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr "Port blockade 🛡️"

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr "Port blockade 🛡️ costs nary a doubloon. 🪙"

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr "Port blockade call-sign 🛡️🔖"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr "Port blockade now open fer raidin’ 🛡️"

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr "Fore-name"

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr "Jolly flags 🚩"

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr "floaty thing"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr "Stash 🗂️"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr "Stash name 🏷️"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr "For every fresh swabbie who joins via the bounty‑by‑buddies scheme and tops up at least {c_minimumTopUp}, Captain pockets {c_promoterCredit} in free booty. 💰"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr "For every fresh swabbie who signs up usin’ Captain’s referral code and adds a verified coin‑route, Captain pockets {c_promoterCredit} o’ free booty. 🏴‍☠️"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr ""

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr "For soul-freezes, ye only pay fer the cargo hold they hog. 📦"

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr "Pull the plug 🔌"

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr "Forgot yer hush‑code? 🔐"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr "Forwardin’ rules 🧭"

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr "Free as the sea 🌊"

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr "Rhythm o’ it 🔁"

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr "startin’ from"

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr "From 🧭"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr "Full map trail 🗺️"

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr "Fully handled hired crew 🤝—we wrangle the ship’s guts and run the show while Captain sips rum. 🍹"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr ""

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr ""

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr "GB"

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr "GB o’ bits 🛢️"

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr "GB o’ RAM"

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr "GBh"

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr "Mint a Captain’s Seal 🔖 to work our <0>API 🧰</0>."

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr "Global 🌍"

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr ""

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr "GST"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr ""

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr "h"

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr ""

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr "Ahoy, world! 🏴‍☠️"

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr ""

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr "In the hammock 😴"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr "Dozin’ off 😴"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr "Bury it 🪦"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr "Bury the tales 🪦"

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr "A stalwart Weight spreader ⚖️ divvies the surge ’twixt Phantom contraptions 👻 within the same hideout 🏝️."

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr "bell-toll 🛎️"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr "Usage be freshened every bell‑toll 🛎️ for the current moon‑turn 🌙."

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr "I can board ⛵"

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr "Aye, I’ve read an’ I bend the knee to the <0>Terms o’ Service</0> ☠️"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr "Aye, I know this be forever ☠️"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr "If thin purse squawks 📉🦜 be awake and yer coffers dip below the line, Captain’ll get a squawk."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr ""

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr "If the ransom‑note coin-route doesn’t fire up instantly, we’ll hail Captain with more tidbits. If no parrot post lands soon or it stays asleep, poke us at <0/>. 📬"

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr "Got questions, nabbed a bilge-bug, or hankerin’ for a shiny feature? Squawk at us via <0>support</0>, Captain. 🦜🛠️"

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr "In the thick o’ battle ⚔️"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr "Dead in the water ⚰️"

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr "boardin’"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr "Inboard laws ⚓️"

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr "Boardin’ traffic only slips through the named ports from the blessed sources—everything else gets keelhauled and blocked. 🛑"

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr "A brag-worthy call-sign 🔖, Captain. It’ll also be used to mint a proper hostname fer the Phantom contraption 👻 (if applicable)."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr "Shipworks 🛠️"

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr "Jam in the rune 🧩"

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr "Stuff in the Mate’s address 🪶 o’ the {siteName} swabbie Captain wants to pass the helm to. They must say aye to the access summons from their profile spyglass 🔭."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr "Yer coffers be empty, Captain. 🪙🚫"

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr "Grafted ID ⚙️"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr ""

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr ""

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr ""

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr ""

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr ""

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Invoice"
msgstr "Ransom note 💸"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr "Ransom note details 💸"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr "Ransom note parrot post 📬"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr ""

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr ""

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr "Ransom notes 💸"

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr "parrot code 🦜"

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr "parrot code 🦜"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr ""

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr "Parrot code 🦜 allowlist"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr "IP prefixes 🪪"

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr ""

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr "Parrot code span 🦜"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr "Sextant cipher span 🧭"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr "ISO hoist ⚙️"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr "Stamped date 🗓️"

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr "Cast off 🏴‍☠️"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr "Keep the floaty thing 🛟"

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr "Mind this, Captain: every stunt be logged and can be tied back to yer mast. 👁️"

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr "Kubernetes Patch Version 🩹"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr "Kubernetes Patch Version auto‑update 🩹"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr "Kubernetes sorcery can’t be conjured, Captain. 🪄🚫"

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr "Sea lingo 🗣️"

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr "Last meddled with 🛠️"

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr "Aft-name"

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr "Latest safety stash ⏳"

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr "Latest soul-freeze 📸"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr "Fewer tales 📉"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr "Daylight mode 🌞"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr "Shackles fall off once the booty refill sum hits <0/>. 💰⛓️"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr "Shackled ⛓️"

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr "Lashed‑together loot ⛓️💰"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr "Weight spreader ⚖️"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr "Load more ⚓️"

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr "Rousin’ the coin‑handler from its hammock 🛌💳"

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr "Hoistin’ the sails… any slower and we’ll fossilize ⚓️🐌"

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr "Hideout 🏝️"

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr "Climb aboard ⚓️"

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr "Climb aboard with Google ⚓️"

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr "Abandon ship 🚪"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr ""

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr ""

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr "Have a snoop ‘round first, Captain. 👀"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr "Thin purse squawk be off, ’cause auto‑refill be awake. 😴🔮"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr "Thin purse squawks 📉🦜"

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr "MAC"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr "Contraption tales ⚙️📜"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr "Contraption be ready fer instant hire—first come, first plunder. ⏱️"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr "Contraption be sailin’ under a client’s flag, tallyin’ coin by the bell. 🛎️💸"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr "Contraption be spoken fer, but her guts ain’t to spec.<0/>Once she’s rigged proper, toss her into “in use.”"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr "Contraption be unavailable or beggin’ fer repairs. 🩹"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr "Contraption needs its Barrels o’ bits swabbed an’ scraped. 🧽🛢️"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr "Contraption ⚙️ type"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr "Patchin’ and mendin’ 🩹"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr "Wrangle ⚓️"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr "Wrangle Admiral’s Port Interface keys 🔑"

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr "Hired crew 🤝"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr "Hired crew 🤝"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr "Max. surge 🌊"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr "Unfurl it ↗️"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr "Max scroll heft be {maxFileSizeInMB} MB, Captain."

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr "MB"

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr "MB/s"

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr "Mbit/s"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr "Coin‑route 🪙"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr "Tallies 📊"

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr "Tallies for this loot ain’t loaded—savin’ speed, lest the ship crawl. 🐌⚓️"

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr "The sorcery be awake on yer account."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr "Stow it ↘️"

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr "Lost at sea 🌊"

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr "Mode ⚙️"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr "moon-turn 🌙"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr ""

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr "Moon-turn toll 💸"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr "More tales 📈"

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr "Multi-sorcery locks (MFA) 🔮"

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr "N/A"

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr "Call-sign 🔖"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr "Call‑sign 🔖 (min {minChars} runes)"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr "Arrr, that call‑sign be too puny! ☠️"

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr "Rigging 🪢"

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr "Riggin’ bandwidth 🪢📶"

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr "Riggin’ interfaces 🪢"

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr "Riggin’ 🪢"

#: src/components/sidebar/SidebarList.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr "Fresh catch 🐟"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr "New file name 🏷️"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr "New stash 🗂️"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr "New stash name 🏷️"

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr "New rigging 🪢"

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr "New hush-code 🔑"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr ""

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr "No active plunder tab 🧾"

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr ""

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr "No scallywag can board the Captain’s account yet. 🗝️"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr "No soul’s shared access with the Captain yet. 🦴"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr "No coin leaves the chest just yet. Captain can swap the coin-route any tide. 🪙"

#: src/components/empty.tsx
msgid "No records"
msgstr "No logs, Captain 🕳️"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr ""

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr "Yer net came up empty 🐟"

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr "No. o' files 📜"

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr "No. o’ resources 📦"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr "No. o’ rules 📜"

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr "Node ⚙️"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr "Node pool 🪣"

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr "Node pools 🪣"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr "nodes ⚙️"

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr "Heed this ⚠️: If Captain sinks a big pile o' loot, the deed may leave a messy deck - some sunk, some clingin'. Should that happen, run the same broadside again."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr "Heed this ⚠️: If yer stash packs a mountain o' files, renamin' will take time and may leave things uneven - some files move, others stay put. If that happens, run the rename on the same stash again."

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr "Heed this, Captain! ⚠️ The owner’ll smell the rum if ye say aye—but they can’t board yer account nor spy or scrawl on any o’ yer loot. 🏴‍☠️"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr "Squawks 🦜"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr "Squawk when coffers sink below ⚓️"

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr "Squawk when the purse sinks below this plank edge. Mind ye—the true limit be set in base coinage. 🦜📉"

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr "Below the waves 🌊"

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr "Once per spin o’ the sun ☀️"

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr "Once a week (Wednesday, 02:00 UTC) ⏰"

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr "One o' yer payin' purses has gone wonky, Captain, so yer buckets be suspended. See <0>payin' purse details</0> for more lore or hail support to fix the mess. 💸⛓️"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr "Still churnin’ ⚙️"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr "Rollin’ coffers 💸"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr "Afloat ⛵"

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr "Only clockwork coin-routes 🤖🪙"

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr "Only the boot barrel gets forged! If the source snapshot’s OS be expectin’ extra barrels, the OS may refuse to hoist its colors proper. Proceed at yer peril, Captain. 💀🛢️"

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr "Operating system ⚙️"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr "Operating system auto‑update ⚙️"

#: src/modules/login/Login.tsx
msgid "Or"
msgstr ""

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr "Tribute chit 📜"

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr "Tribute chits 📜"

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr "OS ⚙️"

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr "castin’ off"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr "Outboard laws 🏳️"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr "Castin’-off traffic only heads to the named ports o’ the marked destinations—every other packet walks the plank. 🌊"

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr "Owed coin 💀"

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr "Tribute be paid 💰"

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr "Secret runes ⚙️"

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr "Hush-code 🔐"

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr "Hush-code fer the mate. Needs at least one wee rune and one shouty rune (a–z, A–Z), plus a digit (0–9). Minimum 8 marks long—else the kraken grumbles. 🦑"

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr "Hush-codes be squabblin’—no match, Captain! ☠️"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr "Path-style URL 🗺️"

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr "Settle the ransom note 💸"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr "Pay the ransom now, Captain! 💸🏴‍☠️"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
msgid "Paying by invoice"
msgstr "Payin’ by ransom note 💸"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr "Payin’ by ransom note (declined / shackled) 💸"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr "Payin’ by ransom note (pendin’) 💸"

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr "Tribute authorization be finished. ✅🪙"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr ""

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr "Coin-route details 🪙"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr ""

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr ""

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment method"
msgstr "Coin-route 🪙"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr "Coin‑routes 🪙"

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr "This coin‑route be slower than a sea slug; once the deed be done, the booty credit’ll slip into Captain’s payin’ purse on its own. 🐌💸"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr "Coin-route kind 🪙"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr ""

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr "pc"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr "Hangin’ in the riggin’ ⏳"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr "Moon‑turn 🌙"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr "Permissions 🗝️"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr "Private ID digits 🕵️"

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr "Phone number ☎️"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr ""

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr ""

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr "Let the pop‑up portholes open, else this coin‑route won’t sail. 🪟🪙"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr "Clamp yer jib, Captain—patience! 🐌"

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr "Pester the support crew to smash the shackles. 🛠️⛓️"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr "Go bother the admirals for more juicy tales. 🧭"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr "Onward, Captain. ⛵"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr "Put in a proper call-sign, Captain. 🏴‍☠️"

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr "Scrawl yer squawk address 🦜 and we’ll fire a parrot post 📬 so ye can reset yer hush‑code, Captain."

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr "Quit dawdlin’, finish addin’ yer squawk address. ⌛"

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr ""

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr "Cast yer spyglass on how the toll o’ yer loot be counted, Captain. 🔍"

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr ""

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr "Pick somethin’ from the list, Captain. 📝"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr "Heave up a copy o’ the trade registry parchment or ID card fer verification (max {maxFileSizeInMB}MB). ☠️"

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr ""

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr ""

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr ""

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr "Port ⚓️"

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr "Port span ⚓️"

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr ""

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr "Tribute up front 💰"

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr "Bounty 💰"

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr "Booty ledger 📜"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr ""

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr "Booty per bell-toll 🛎️"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr "Booty per moon-turn 🌙"

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr "Prices may sway like a drunken mast for the choices below, arr! 🍻"

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr "Flagship 🚩"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr "Private 🔒"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr ""

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr "Private IP 🕶️"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr "Private parrot code 🦜"

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr "Private riggin’ 🪢"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr ""

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr "Profile 🦜"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr "Parley code 📜"

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr "The Provider’s open tide for patchin’—a window when they may auto‑update yer cluster, like it or not, Captain. ⏳"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr "Public 🌊"

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr "Public parrot codes be managed in the Rigging—spyglass it there. 🦜🪢"

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr "Public parrot code 🦜"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr "Public sextant angle 🧭"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr ""

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr ""

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr "Public riggin’ 🪢"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr "Public URL 🗺️"

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr "Qty. ⚓️"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr ""

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr "RAM 🧠"

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr "RDP tether ⛓️"

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr "Spyglass more tales 🔭"

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr "Shipshape‑ness ⛵"

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr "Shipshape ✅"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr "Hoist again 🏴‍☠️"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr "Fresh haul 🆕"

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr "Steerin’ to the coin portal 🧭💳"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr "Bounty‑by‑buddies code 🪝"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr "Bounty‑by‑buddies link 🪝"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr "Bounty‑by‑buddies scheme 🪝🤝"

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr "Rattle the status cage 🦜"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr "Registry digits 🧾"

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr "Reinstall 🔁"

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr "Reinstallin’ \"{name}\" will scorch all booty on the boot barrel and reset it to a squeaky-clean OS. Snapshots an’ safety stash be spared. 🔥🧼"

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr "Reload the cannons 🔄"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr "Reload the loot 📦"

#: src/root.tsx
msgid "Reload page"
msgstr ""

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr "Leftover booty <0/> 💰"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr "Unlash loot ✂️"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr "Yankin’ the public parrot code 🦜 off this loot makes it vanish from the open seas. The code stays stashed in Captain’s purse regardless. Manage yer public parrot codes from the Rigging 🪢 menu on the portside bar."

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr "Bootin’ this mate overboard will strip “{0}” o’ the right to sail as Captain. 🌊"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr "Rename ✍️"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr "Ransom note 💸"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr "Ransom note {id} 💸"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr "Logbooks 📜"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr ""

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr ""

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr "Claimed 🏴‍☠️"

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr "Reset hush-code 🔐"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr "Stretch 📏"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr "Stretch the barrel o’ bits 🛢️"

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr "Stretchin’ be only allowed when the phantom contraption 👻 be anchored. ⚓️"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr "Loot call-sign 🔖"

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr "Booty 🏴‍☠️"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr "resources in the same Secret harbor network 🤫⚓️ usin’ private addresses of primary interfaces"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr "resources in Secret harbor networks 🤫⚓️ shared by VLAN sub-interfaces, usin’ their respective private address"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr ""

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr "Haul back 🪝"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr ""

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr "Haulin’ from a Safety stash 🕰️ will overwrite the Hired crew’s 🤝 state with the chosen stash’s state. Heed this ⚠️"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr ""

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr "Shackled ⛓️"

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr ""

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr "Heave ho again! 🔁"

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr ""

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr "RNE parchment 📜"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr "Rules from every port blockade 🛡️ ye’ve lashed on get tossed in the same stew; if even one says “aye,” the traffic sails through. ⚓️"

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr "Run yer contraptions on Naked brutes 💪 for full helm‑control, ironclad safety, an’ raw thunderspeed. Commission a dedicated ironbeast tuned fer yer most cutthroat voyages, Captain. ⚡️"

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr "Sailin’ ⛵"

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr ""

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr "Stash it 💾"

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr "Stashin’ Captain’s coin‑route secrets in the hold 🧰"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr "Scan the squiggle‑box to toss coin, Captain. 🧾📸"

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr "Plunder scope 🗺️"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr "Secret hatch pass 🤫"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr "Snag a scroll, Captain 📜"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr "Pick a coin-route, Captain 🪙"

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr "Pick yer poison, Captain ☠️"

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr "Captain, pick the shiny coin ye want to spy prices in. Shown sums and coin‑swap rates be just hints for yer eyeballs. All trades be settled in the true under‑currency ({0}), and the final bite may sway with yer coin‑handler’s rates. 🪙⚓️"

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr "Pick yer favorite shiny coin, Captain 🪙"

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr "Fire the broadside 💥🏴‍☠️"

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr "Send the parrot post 📬"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr "Ironbeast 🦾"

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr "Ship class 🛳️"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr "Hired crew 🤝"

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr "Hired crew 🤝 Call-sign 🔖"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr "Hired crew 🤝"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr "Put a pin in it 📌"

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr "Set the booty's ACL to 'private' 🔒"

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr "Set the booty's ACL to 'public-read' 📣"

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr "Pass the helm ⛵"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr ""

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr "Share fer a spell ⏳"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr "Share span ⌛"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr "Reveal the loot 💰"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr "Reveal the loot 💰"

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr "Revealin' {limit} latest loot 💰"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr ""

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr "Join the crew 🏴‍☠️"

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr "Join the crew with Google 🏴‍☠️"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr "Size 📏"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr "Girth (GB) 📏"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr "Soul-freezes 📸"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr "Crow’s‑nest holler 📣"

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr "Picked clean o’ booty 🦴"

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr "Rank 'em 📜"

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr "Rank by 📜"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr "Rank by date 🗓️"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr "Rank by Call-sign 🔖"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr "Rank by size 📏"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr "Source port 🧭"

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr "Origins 🧭"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr "Yer SSH key be a misfit—don’t match the sacred pattern. 🪓"

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr ""

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr "SSH tether ⛓️"

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr "SSH might snub the root scallywag thanks to the OS’s first-time shenanigans. Board via the phantom console, then tweak the SSH server to yer whims, Captain. 👻🛠️"

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr "Set sail ⛵"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr ""

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr "Cast off here ⚓️"

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr "Grab the helm o’ yer rigging—spawn fresh rigging loot and start bossin’ it around. 🧭"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr ""

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr ""

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr "Spawn new loot 🐣"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr "Kickoff bell‑toll 🛎️"

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr "Hoistin’ the tribute sails 💸⛵"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr "Status ☠️"

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr "Drop anchor ⚓️"

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr "Anchored ⚓️"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr "Heavin’ to… ⛔"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr "Cargo hold 📦"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr "Cargo hold hatch passes 🔑"

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr "Loot bucket 🪣"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr "Loot bucket call-sign 🔖"

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr "Dockside mark 🗺️"

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr "String o’ runes 🧵"

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr "Sub‑booty 💰"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr "In irons ⛔"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr "Swap to Grid spyglass 🔭"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr "Swap to List spyglass 🔭"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr "ship’s system ⚙️"

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr "Snag a soul-freeze to freeze yer phantom contraption’s current soul. Later, use it to restore the beast or spawn a fresh one with tweaked girth from that freeze. ❄️👻"

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr "Snatch a soul-freeze 📸"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr "Do somethin’ useful and the Captain’ll never spy this cursed cactus again. 🌵😈"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr "Target port 🎯"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr "Target ships 🎯"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr "Brig Terminal 🖥️"

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr "Terms o’ Service ☠️"

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr "The true cost o’ yer loot be reckoned by the prices below and yer real bell‑toll usage. All prices be per one unit o’ loot (1 vCPU or 1 GiB). No crown‑levies included, har! ☠️"

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr "The payin’ purse be scuttled—no longer on the charts. ❌🗺️"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr "The campaign rune awakens only after a successful booty refill. 💰"

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr "The whole helm deck'll slip on their boots and pretend ye be that soul. When ye're done, hit \"Back to yer account\" on the top rail, and the helm'll snap back to yer own cabin."

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr "Final swap rate and toll be set at the moment o’ payin’. ⏳💱"

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr "Yer first booty refill unlocks Captain’s complimentary free booty of <0><1/></0>. 🎁💰"

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr "This link expires on: ⏰"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr "Yer call-sign can only have wee runes an' dashes; start with a wee letter or number; length 3-63. Step outta line an' ye walk the plank! ☠️"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr "The hush-code can be swapped fer any existin’ mate’s account, Captain. 🔐"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr "The speakin’‑shell digits to hail if trouble rears its barnacled mug ☎️🐙"

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr "A rough chart, Captain—the toll for yer loot be reckoned by yer true bell‑toll spendin’. ⏳"

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr "The re-typed hush-code—so ye don’t fat-finger the treasure key. 🗝️"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr ""

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr "The mate’s account what the hush-code’ll be nailed to. 🪝"

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr "Arrr, the squawk‑proofin’ hit the rocks! 💥🦜"

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr "A curse struck while spawnin’ yer loot, Captain. 💀"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr "These passes be only fer the first boarding. Change the hush‑codes right quick, Captain. ⏱️🔐"

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr "This Naked brute be still riggin’ up."

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr "This payin’ purse be shackled—limited might when spawnin’ loot. ⛓️"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr "Payin’ purse be shackled ⛓️"

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr ""

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr ""

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr ""

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr ""

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr "This Hired crew 🤝 be reachable only by loot in the same Secret harbor network 🤫⚓️ usin’ these private parrot codes 🦜."

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr "This phantom contraption be reachable by: 👻"

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr ""

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr "This’ll force-shut yer loot “{name}”. When it’s stopped, Captain, ye only pay fer the cargo hold. ⚓📦"

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr "Only used aboard this ship, so it’s easy fer Captain to spot which payin’ purse be which when ye’ve got a fleet. 🧭"

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr "This’ll hoist “{name}” again, Captain—hold on to yer hat. 🎩⚡"

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr "This’ll toss the code or range overboard from the allowlist.<0/>An empty list means any scallywag can board from any address—ye been warned. ⚠️"

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "This’ll snuff yer loot “{display_name}”. If the gentle goodnight ain’t done in 120 seconds, we’ll Pull the plug 🔌. While it sleeps, ye only pay for the Cargo hold 📦."

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "This’ll keelhaul yer loot \"{name}\". If the dainty shutdown ain’t done in 120 seconds, we’ll pull the plug the hard way. When anchored, ye only pay fer the cargo hold 📦. ⏳🔌"

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr "This’ll halt the cannon fire to yer targets and scuttle the load balancer. Boom. 💣"

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr "Plank edge ☠️"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr ""

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr ""

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr ""

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr "Sea‑clock zone ⌚"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr "To wake a payin’ purse, slap on a plunder tab as a coin-route, or signal the support crew to enable ransom‑note payin’. 🧾💸"

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr "To clamp down access to the Hired crew 🤝, add at least one inbound parrot code 🦜 to the allowlist (all other public and private links get keelhauled). Ye can peg a single parrot code 🦜 or a block usin’ CIDR (e.g. 1.1.1.0/24)."

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr "To start usin’ the platform, first rig a payin’ purse, Captain. Click about, get cozy with the riggin’, then swing back to spawn that payin’ purse whenever ye’re ready to forge yer first loot. 🏴‍☠️"

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr "To use our services, ye must swear to the Terms o’ Service, Captain. ☠️"

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr "Captain’s Seal 🔖"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr "Booty refill 💰"

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr "Booty refill sum 💰"

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr "Refill at least <0><1/></0> o’ booty to snag <2><3/></2> o’ bounty‑by‑buddies bonus. 🪝💰"

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr "Refill the payin’ purse now 💰"

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr "Top up the payin’ purse, Captain! 💰"

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr "Top-up ransom notes 💸"

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr "Booty refill chits 💰📜"

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr "Total haul 💰"

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr "Grand toll 💰"

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr "Total (excl. {vatSymbol}) ☠️"

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr "Grand heap o’ unpaid ransom notes—{vatSymbol} included. 💸"

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr "Sum o’ all unpaid chits—VAT tossed in. 💸☠️"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr "Trade toll 🏴‍☠️"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr "Type o’ loot 🏴‍☠️"

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr ""

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr "Deck UI 🎛️"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr "Cast adrift 🛟"

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr "Adrift 🛟"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr "Unit ⚙️"

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr "Mystery fog 🌫️"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr ""

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr "Unknown payin’ purse 💸"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr ""

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr "Mystery loot 🕵️‍☠️"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr "Cut the rope to target ✂️"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr "Unpaid 💀"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr "Owed coin 💀"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr "Unproven 🧐"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr ""

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr ""

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr "Heave it up ⬆️"

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr "Heave up a copy o’ only the RNE parchment fer verifyin’, Captain. 📤🕵️‍♂️"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr "Hoistin' files ⛵📤"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr "What ye burned 🔥"

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr "Crew access 🏴‍☠️"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr "Mate must say aye to the summons from their profile spyglass 🔭"

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr "Matey view 🦜"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr "Mate’s address 🪶"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr "Call-sign 🔖"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr "Mates I can board ⛵"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr "Mates who can board me account ⚓️"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr "UUID"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr "Seaworthy thru ⛴️"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr "Verification be swayin’ in the breeze… ⏳"

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr ""

#: src/components/VatText.tsx
msgid "VAT"
msgstr "Plunder tax 🏴‍☠️"

#: src/components/VatText.tsx
msgid "VAT number"
msgstr "Plunder tax code 🏴‍☠️"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr "vCPU ⚙️"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr "Proven true ✅"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr "The Captain’s tribute method be missin’ its seal—no verified coin path! 🕳️"

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr "Verifyin’ the coin‑route 🪙"

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr "Vintage 🏷️"

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr "Spyglass it 🔭"

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr "Spyglass every log 📜"

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr "Spyglass the config commands 🔭"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr "Spyglass the details 🔭"

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr "Spyglass the last {limit} logs 🔭"

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr "Spyglass more 🔭"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr "Phantom host-style URL 👻"

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr "Phantom contraption 👻"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr "VLAN 🪢"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr "VLAN mark 🏷️"

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr "Secret harbor network 🤫⚓️ parrot code 🦜 range"

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr "Secret harbor call-sign 🤫⚓️🔖"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr "Secret harbor network 🤫⚓️"

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr "VPC rigging be free as the wind—zero doubloons. 💸"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr "Drop anchor till verification, or slap on a plunder tab. ⛵🧾"

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr "Waitin’ for tribute confirmation squawk 🦜⌛"

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr ""

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr "Shakin’ awake ☕⛵"

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr "Heed this ⚠️"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr "Heed this ⚠️: Best drop anchor on the phantom contraption 👻 afore stretchin’ the boot barrel."

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr "We reckon Captain slap a plunder tab 🧾 on file while the request be churnin’, so the hired crew springs to life straightaway. ⚡"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr "We recommend auto‑refill, so yer coffers don’t run dry and scuttle yer server loot, Captain. 🤦‍☠️💸"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr "We’ve lashed some links to shove the Captain out the harbor. Build, test yer code-spells, an’ launch yer apps quick as a cannon shot—from wee prototypes to full-blown armadas. ⚓️🚀"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr "We hit the file spyglass's limits. To keep the helm deck steady, we've stopped loadin' yer bucket's guts. Use yer own shore tools to wrangle the contents within yer bucket. ⚓️"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr "Ahoy! 🏴‍☠️"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr "Welcome!<0/>We be glad the Captain washed ashore. 🎉"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr "So, Captain, what’s yer grand plan? 🦜"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr "When the purse sinks below ⚓️"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr "If ye hoard it without lashin’ it to loot, the parrot code 🦜 bleeds ye for <0/> / moon-turn 🌙."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr "When flagged, a public driftin’ parrot code 🦜 be forged and slapped on yer loot automatic-like. If Captain ain’t cravin’ the open-seas spotlight, un-tick it here or toss the code overboard later. ⚓️🌊"

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr "When Captain flips on the safety-stash service, we’ll auto-snag a disk-level copy from the boot barrel o’ bits (spare barrels not included). One stash each week, listed here. Later, Captain can use those images to resurrect yer phantom contraption or spawn a new one with tweaked girth from the stash. ⛵🛢️"

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr "While the crew sweats 💦, ye can:"

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr "With a port blockade 🛡️ Captain commands the in‑an’‑out riggin’ traffic by the sacred scribbles o’ yer rules. ⚓️"

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr "With yer first payin’ purse, Captain unlocks a complimentary stash o’ coin worth <0><1/></0>. 💰"

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr "With the chosen coin-route, Captain, the toll be in {0}. 🪙"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr "Without an active payin’ purse the Captain can’t spawn any loot; forge one to shove off. 🏴‍☠️"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr "Without a lively payin’ purse, no loot gets forged, Captain. 🚫💰"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr ""

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr ""

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr "Aye ⚓️"

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr "Ye be 'bout to board the deck o' \"{name}\" ⛵"

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr "Captain be the admiral here, handin’ the crown to another—make sure this ain’t a drunken click. 🍻⚠️"

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr "Captain can awaken multi-sorcery locks fer beefier security. Works only with the username-password hatch. For social logins (Google and the rest), ye usually flip MFA on their side o' the dock."

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr "Captain can hoist yer phantom contraption 👻 from a special image to patch the hull or install a fresh OS. When this mode be lit, the chosen image gets lashed on as the boot trinket. Then board via the Terminal to wrangle yer ironbeast. This fancy hoist be for this launch only—next time the beast follows the usual wake-up ritual. ⚓"

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr "Batten the hatch on this page, Captain. ⚓️"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr "Captain can spawn multiple payin’ purses, each lashed to its own coin-route. Keeps the spendin’ split and watchable ‘twixt crews, decks, or quests. 💸🗺️"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr "Do it here, then keep sailin’ later via the shiny link in the parrot post we squawk at Captain. 🦜🔗"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr "Captain can rake in and gift free booty by sharin’ Captain’s one‑of‑a‑kind referral code. 🪝💸"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr ""

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr ""

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr "Behold, Captain! The driftin’ IP <0>{0}</0> clings to this here loot. 🏴‍☠️"

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr "Captain’s got an active campaign code (<0>{referralCode}</0>) waitin’ to cough up extra booty! 🪙🎁"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr "Captain’s payin’ purse 💸 proving be mid‑voyage."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr "Captain’s finished the payin’ purse 💸 proving. Drop anchor and await the grand verdict… ⏳⚖️"

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr "No squawks in yer coop, Captain—dead quiet… too quiet. 🦜🤫"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr "Captain may batten the hatch ⚓️ once ye’ve paid the tribute. 💰"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr "Captain may batten the hatch on this chatter‑box for now. ⚓️"

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr ""

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr "Once the proving be blessed, Captain can rig coin‑routes 🪙 and ride the cloud seas like a proper marauder. ☁️🏴‍☠️"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr "Captain’ll rig coin‑routes and sail the cloud seas once the verification be done. ⛅⚓️"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr "Yer payin’ purse stays shut till she’s shipshape. ⏳💰"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr "The Captain’s account be in irons. ⛔💀"

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr "Yer real toll be <0/>, with a swap rate o’ <1/>. 💱"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr "Yer payin’ purse be put in irons ⛔. Spyglass its details fer more lore and <0>signal the support crew</0> to uncurse the mess. ⚓️"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr "Captain’s payin’ purse be brimmin’—booty refill complete! 💸🏴‍☠️"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr "Yer payin’ purse needs coin above zero to spring to life, Captain. ➕💰"

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr "Yer squawk address be proven. Now climb aboard, Captain. ⚓️"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr "Yer squawk address 🦜 shifted since ye set sail on the proving. Start over, Captain. 🔁"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr "Yer loot bucket holds a hefty swarm o' files, so we've dropped anchor on loadin' for now. Just click the \"Load More\" button to haul in the next batch. 🐙"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr "Post mark code 📮"
